define('ext/bootstrap/dropselect',[
  "jquery"
], function ($) {
  "use strict";

  function DropSelect(el, options) {
    options = options || {};

    this.el = el;
    this.options = $.extend({}, $.fn.dropselect.defaults, options);

    this.list = this.el.find("ul, ol");
    this.first = this.list.find("li:first a");
    this.notFirst = this.list.find("li:not(:first) a");
    this.button = this.el.find("button");

    this.first.on("click", $.proxy(this.reset, this));
    this.notFirst.on("click", $.proxy(this.onClick, this));
    this.el.on("dropselect:reset", $.proxy(this.reset, this));

    this.initial = options.initial || this.first;

    return this.select(this.initial);
  }

  DropSelect.prototype.createIndicator = function () {
    var indicator = document.createElement(this.options.indicatorElement);
    indicator.className = this.options.indicatorClass;
    return $(indicator);
  };

  DropSelect.prototype.getSelectedItems = function () {
    var className = this.options.itemSelectedClass;

    return this.list.find("li:not(:first) a").filter(function () {
      return $(this).hasClass(className);
    });
  };

  DropSelect.prototype.hasSelectedItems = function () {
    return this.getSelectedItems().length > 0;
  };

  DropSelect.prototype.isSelected = function (item) {
    return item.hasClass(this.options.itemSelectedClass);
  };

  DropSelect.prototype.reset = function () {
    if (!this.isSelected(this.first)) {
      this.select(this.first);
    }

    this.deselect(this.notFirst);

    return this;
  };

  DropSelect.prototype.onClick = function (e) {
    e.preventDefault();
    return this.toggle($(e.currentTarget));
  };

  DropSelect.prototype.toggle = function (item) {
    if (this.isSelected(item)) {
      this.deselect(item);

      if (!this.hasSelectedItems() && !this.isSelected(this.first)) {
        this.select(this.first);
      }
    } else {
      this.deselect(this.first);
      this.select.call(this, item);
    }

    return this;
  }

  DropSelect.prototype.select = function (item) {
    if (!this.options.allowMultiple) {
      this.deselect(this.getSelectedItems());
    }

    item.addClass(this.options.itemSelectedClass)
        .append(this.createIndicator());

    return this.toggleButtonState();
  },

  DropSelect.prototype.removeIndicator = function (item) {
    item.find(this.options.indicatorElement).remove();
    return this;
  };

  DropSelect.prototype.deselect = function (items) {
    this.removeIndicator(items.removeClass(this.options.itemSelectedClass));
    return this.toggleButtonState();
  },

  DropSelect.prototype.toggleButtonState = function () {
    this.button.toggleClass(
      this.options.buttonSelectedClass,
      this.hasSelectedItems());

    if (this.button.hasClass(this.options.buttonSelectedClass)) {
      this.button.removeClass(this.options.buttonDefaultClass);
    } else {
      this.button.addClass(this.options.buttonDefaultClass);
    }

    return this;
  };

  $.fn.dropselect = function (options) {
    return this.map(function () {
      return new DropSelect($(this), options);
    });
  };

  $.fn.dropselect.defaults = {
    buttonDefaultClass:  "btn-default",
    buttonSelectedClass: "btn-info",
    itemSelectedClass:   "active",
    indicatorElement:    "i",
    indicatorClass:      "indicator fa fa-check",
    initial:             null,
    allowMultiple:       true,

    // TODO: Implement event support.
    onChange:            function () { /* noop */ }
  };

  return DropSelect;
});

